import util from './shared/util.js';
import config from '../config.js';

const servicesURL = `${config.server.url}:${config.server.webServicesPort}/service/`;

class cdoService {
    create = (data, callback) => {
        util.putJSON(servicesURL + 'create', data, callback);
    }

    update = (data, callback) => {
        util.putJSON(servicesURL + 'update', data, callback);
    }

    selectAll = (callback) => {
        util.getJSON(`${servicesURL}select-all`, callback);
    }

    select = (data, callback) => {
        util.putJSON(servicesURL + 'select', data, callback);
    }

    delete = (data, callback) => {
        util.putJSON(servicesURL + 'delete', data, callback);
    }
}

const cdo = new cdoService();
export default cdo;
